import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=bb4b397c&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4b397c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb4b397c')) {
      api.createRecord('bb4b397c', component.options)
    } else {
      api.reload('bb4b397c', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=bb4b397c&scoped=true&", function () {
      api.rerender('bb4b397c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UOs17CX217yi/JS/comp/Voucher-Unit.vue"
export default component.exports